import {
  CANVAS_SIZES,
  MATERIAL_TYPES,
  TILE_SIZES,
} from '@mixtiles/web-backend-shared'
import {
  type ExperimentManager,
  experimentManager as defaultExperimentManager,
} from '../../services/ExperimentManager/ExperimentManager'

export const ALL_SIZES = [
  TILE_SIZES.SQUARE_8X8,
  TILE_SIZES.RECTANGLE_8X11,
  TILE_SIZES.RECTANGLE_11X8,
  TILE_SIZES.SQUARE_12X12,
  TILE_SIZES.RECTANGLE_12X16,
  TILE_SIZES.RECTANGLE_16X12,
  TILE_SIZES.SQUARE_20X20,
  TILE_SIZES.RECTANGLE_20X27,
  TILE_SIZES.RECTANGLE_27X20,
]

export const getOrderedSizes = (
  materialType = MATERIAL_TYPES.CLASSIC, // this is a small hack to make sure this function works in SSR
  experimentManager: ExperimentManager = defaultExperimentManager
) => {
  if (materialType === MATERIAL_TYPES.STICKER) {
    return [TILE_SIZES.SQUARE_30X30, TILE_SIZES.SQUARE_40X40]
  }
  if (materialType === MATERIAL_TYPES.CANVAS) {
    return CANVAS_SIZES
  }

  const sizes: TILE_SIZES[] = []

  sizes.push(...ALL_SIZES)

  if (experimentManager.isEnabled('xl-sizes')) {
    sizes.push(TILE_SIZES.RECTANGLE_27X36, TILE_SIZES.RECTANGLE_36X27)
  }

  if (experimentManager.isEnabled('size-22x44')) {
    sizes.push(TILE_SIZES.RECTANGLE_22X44, TILE_SIZES.RECTANGLE_44X22)
  }

  return sizes
}
